import "./MarketplaceFooterStrip.css";

/* Shared footer strip for the public Advisor Marketplace + all advisor profiles. */
export const MarketplaceFooterStrip = () => (
  <div className="mfs" data-testid="marketplace-footer-strip">
    <div className="mfs-checks">
      <span className="mfs-item"><i className="ti ti-check" aria-hidden="true" /> Open to all founders &amp; firms</span>
      <span className="mfs-item"><i className="ti ti-check" aria-hidden="true" /> Verified experts only</span>
      <span className="mfs-item"><i className="ti ti-check" aria-hidden="true" /> Direct messaging</span>
      <span className="mfs-item"><i className="ti ti-check" aria-hidden="true" /> No IPO Navigator account required</span>
    </div>
    <p className="mfs-note">
      Advisor Marketplace is an independent directory operated by IPOLabs, open to any founder, CA firm, or advisor — with or without an IPO Navigator account.
    </p>
  </div>
);

export default MarketplaceFooterStrip;
